import {Component, OnInit} from '@angular/core';
import {GlobalLoaderService} from '../services/global-loader.service';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {RouterModule} from '@angular/router';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, TranslateModule, RouterModule],
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  resourcesLoaded: boolean;

  constructor(private loader: GlobalLoaderService) {
  }

  ngOnInit() {
    this.loadResources();
  }

  private async loadResources() {
    await this.loader.loadExternalStyles('/bootstrap/css/bootstrap.min.css');
    await this.loader.loadExternalStyles('/assets/css/plugins.css');
    await this.loader.loadExternalStyles('/assets/css/authentication/form-2.css');
    await this.loader.loadExternalStyles('/assets/css/forms/theme-checkbox-radio.css');
    await this.loader.loadExternalStyles('/assets/css/forms/switches.css');
    await this.loader.loadExternalStyles('styles.css');

    await this.loader.loadExternalScript('/assets/js/libs/jquery-3.1.1.min.js');
    await this.loader.loadExternalScript('/bootstrap/js/popper.min.js');
    await this.loader.loadExternalScript('/bootstrap/js/bootstrap.min.js');
    await this.loader.loadExternalScript('/assets/js/authentication/form-2.js');
    this.resourcesLoaded = true;
  }
}
